export default "__VITE_ASSET__B7ya8p2u__"